import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { ConfirmationDialogueComponent } from 'app/components/common/confirmation-dialogue/confirmation-dialogue.component';
import { IIndividualAddress } from 'app/models/individuals/individual-address';
import { CommonService } from 'app/services/common/common.service';
import { SharedService } from 'app/services/core/shared.service';
import { IndividualService } from 'app/services/individuals/individual.service';
import { ToastrService } from 'ngx-toastr';
import { PUBLIC_FIRM_ADDRESS_TYPES } from '../../firms/firm-edit/firm-edit.constants';

@Component({
  selector: 'app-individual-edit-address-dialog',
  templateUrl: './individual-edit-address-dialog.component.html',
  styleUrls: ['./individual-edit-address-dialog.component.scss']
})
export class IndividualEditAddressDialogComponent implements OnInit {
  public addressDataForm = null;
  public addressData!: IIndividualAddress;
  public uiData = LEAD_BASED_PAINT;
  public color = this.uiData.individual.color;

  constructor(
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: { address: IIndividualAddress },
    private readonly toastr: ToastrService,
    private readonly individualService: IndividualService,
    private readonly commonService: CommonService,
    private readonly dialogRef: MatDialogRef<IndividualEditAddressDialogComponent>,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.initializeDataFormFields();
    this.loadData();
  }

  loadData(): void {
    this.addressData = this.data.address;
    this.loadDataForm();
  }

  initializeDataFormFields(): void {
    this.addressDataForm = new UntypedFormGroup({
      contactType: new UntypedFormControl(''),
      street: new UntypedFormControl(''),
      city: new UntypedFormControl(''),
      state: new UntypedFormControl(''),
      zip: new UntypedFormControl(''),
      county: new UntypedFormControl(''),
      isCurrentPhysical: new UntypedFormControl(false),
      isCurrentMailing: new UntypedFormControl(false),
    });
  }

  loadDataForm(): void {
    for (const controlName in this.addressData) {
      if (this.addressDataForm.controls.hasOwnProperty(controlName)) {
        this.addressDataForm.controls[controlName].setValue(this.addressData[controlName]);
      }
    }

    for (const controlName in this.addressData.address) {
      if (this.addressDataForm.controls.hasOwnProperty(controlName)) {
        this.addressDataForm.controls[controlName].setValue(this.addressData.address[controlName]);
      }
    }
  }

  updateAddressData(): void {
    for (const controlName in this.addressData) {
      if (this.addressDataForm.controls.hasOwnProperty(controlName)) {
        this.addressData[controlName] = this.addressDataForm.controls[controlName].value;
      }
    }

    for (const controlName in this.addressData.address) {
      if (this.addressDataForm.controls.hasOwnProperty(controlName)) {
        this.addressData.address[controlName] = this.addressDataForm.controls[controlName].value;
      }
    }
  }

  getAddressTypes(): string[] {
    return Object.values(PUBLIC_FIRM_ADDRESS_TYPES);
  }

  savePrompt(): void {
    const isNew = this.addressData.id === 0;
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {
        message: isNew ? 'Are you sure you want to <strong>Add</strong> this Address?' : 'Are you sure you want to <strong>Update</strong> the Address?',
        title: isNew ? 'Add the Address' : 'Update the Address'
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveData();
      }
    });
  }

  saveData(): void {
    this.updateAddressData();

    this.commonService.saveAddress(this.addressData.address).subscribe({
      next: (savedAddress) => {
        this.addressData.address = savedAddress;
        this.individualService.saveIndividualAddress(this.addressData).subscribe({
          next: () => {
            this.toastr.success('Address saved successfully!');
            this.dialogRef.close(true);
          },
          error: (error) => this.toastr.error('Error saving Address: ' + (error?.message || error?.error || 'Unknown error')),
        });
      },
      error: (error) => this.toastr.error('Error saving Address: ' + (error?.message || error?.error || 'Unknown error')),
    });
  }
}